<template>
  <div>
    <div class="page-head">
      <div>
        <h2>支出分类</h2>
        <p>统一管理支出用途分类</p>
      </div>
      <el-button
        type="primary"
        @click="dialog = true"
      >
        新增分类
      </el-button>
    </div>
    <el-card shadow="never">
      <el-table
        :data="rows"
        v-loading="loading"
      >
        <el-table-column
          prop="name"
          label="分类名称"
        />
        <el-table-column label="状态">
          <template #default="{ row }">
            <el-tag :type="row.enabled ? 'success' : 'info'">
              {{ row.enabled ? '启用' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template #default="{ row }">
            <el-button
              link
              :type="row.enabled ? 'danger' : 'success'"
              @click="toggle(row)"
            >
              {{ row.enabled ? '停用' : '启用' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog
      v-model="dialog"
      title="新增支出分类"
      width="420px"
    >
      <el-input
        v-model="name"
        placeholder="分类名称"
      />
      <template #footer>
        <el-button @click="dialog = false">取消</el-button>
        <el-button
          type="primary"
          :loading="saving"
          @click="save"
        >
          保存
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import { onMounted, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { ledgerApi } from '../api'
const rows = ref([]),
  loading = ref(false),
  dialog = ref(false),
  saving = ref(false),
  name = ref('')
const load = async () => {
  loading.value = true
  try {
    rows.value = (await ledgerApi.expenseCategories()) || []
  } finally {
    loading.value = false
  }
}
const save = async () => {
  if (!name.value.trim()) return ElMessage.warning('请输入分类名称')
  saving.value = true
  try {
    await ledgerApi.createExpenseCategory({ name: name.value })
    name.value = ''
    dialog.value = false
    load()
  } catch (e) {
    ElMessage.error(e?.message || '保存失败')
  } finally {
    saving.value = false
  }
}
const toggle = async (r) => {
  try {
    await ledgerApi.toggleExpenseCategory(r.id, !r.enabled)
    load()
  } catch (e) {
    ElMessage.error(e?.message || '操作失败')
  }
}
onMounted(load)
</script>
<style scoped>
.page-head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.page-head h2 {
  font-size: 24px;
}
.page-head p {
  color: #8492a6;
  margin-top: 6px;
}
.el-card {
  border: 0;
}
</style>
